// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"B8-z","paperCutsLineHeight":"C8-z"};